import _classCallCheck from "/tmp/build_f973a96b/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/tmp/build_f973a96b/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/tmp/build_f973a96b/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/tmp/build_f973a96b/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/tmp/build_f973a96b/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React$1, { Component } from 'react';
import 'focus-visible/dist/focus-visible';
import { ThemeProvider as ThemeProvider$1 } from '../ThemeProvider/ThemeProvider.js';
import { MediaQueryProvider as MediaQueryProvider$1 } from '../MediaQueryProvider/MediaQueryProvider.js';
import { UniqueIdFactoryContext } from '../../utilities/unique-id/context.js';
import { UniqueIdFactory, globalIdGeneratorFactory } from '../../utilities/unique-id/unique-id-factory.js';
import { FocusManager as FocusManager$1 } from '../FocusManager/FocusManager.js';
import { PortalsManager as PortalsManager$1 } from '../PortalsManager/PortalsManager.js';
import { I18nContext } from '../../utilities/i18n/context.js';
import { I18n as I18n$1 } from '../../utilities/i18n/I18n.js';
import { ScrollLockManagerContext } from '../../utilities/scroll-lock-manager/context.js';
import { ScrollLockManager } from '../../utilities/scroll-lock-manager/scroll-lock-manager.js';
import { StickyManagerContext } from '../../utilities/sticky-manager/context.js';
import { StickyManager } from '../../utilities/sticky-manager/sticky-manager.js';
import { LinkContext } from '../../utilities/link/context.js';
import { FeaturesContext } from '../../utilities/features/context.js';
import './AppProvider.scss.js';
var AppProvider = /*#__PURE__*/function (_Component) {
  _inherits(AppProvider, _Component);
  function AppProvider(props) {
    var _this;
    _classCallCheck(this, AppProvider);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(AppProvider).call(this, props));
    _this.stickyManager = void 0;
    _this.scrollLockManager = void 0;
    _this.uniqueIdFactory = void 0;
    _this.stickyManager = new StickyManager();
    _this.scrollLockManager = new ScrollLockManager();
    _this.uniqueIdFactory = new UniqueIdFactory(globalIdGeneratorFactory);
    var _this$props = _this.props,
      i18n = _this$props.i18n,
      linkComponent = _this$props.linkComponent; // eslint-disable-next-line react/state-in-constructor
    _this.state = {
      link: linkComponent,
      intl: new I18n$1(i18n)
    };
    return _this;
  }
  _createClass(AppProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (document != null) {
        this.stickyManager.setContainer(document);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var prevI18n = _ref.i18n,
        prevLinkComponent = _ref.linkComponent;
      var _this$props2 = this.props,
        i18n = _this$props2.i18n,
        linkComponent = _this$props2.linkComponent;
      if (i18n === prevI18n && linkComponent === prevLinkComponent) {
        return;
      } // eslint-disable-next-line react/no-did-update-set-state

      this.setState({
        link: linkComponent,
        intl: new I18n$1(i18n)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        _this$props3$theme = _this$props3.theme,
        theme = _this$props3$theme === void 0 ? {} : _this$props3$theme,
        children = _this$props3.children;
      var _this$state = this.state,
        intl = _this$state.intl,
        link = _this$state.link;
      return /*#__PURE__*/React$1.createElement(FeaturesContext.Provider, {
        value: this.props.features || {}
      }, /*#__PURE__*/React$1.createElement(I18nContext.Provider, {
        value: intl
      }, /*#__PURE__*/React$1.createElement(ScrollLockManagerContext.Provider, {
        value: this.scrollLockManager
      }, /*#__PURE__*/React$1.createElement(StickyManagerContext.Provider, {
        value: this.stickyManager
      }, /*#__PURE__*/React$1.createElement(UniqueIdFactoryContext.Provider, {
        value: this.uniqueIdFactory
      }, /*#__PURE__*/React$1.createElement(LinkContext.Provider, {
        value: link
      }, /*#__PURE__*/React$1.createElement(ThemeProvider$1, {
        theme: theme
      }, /*#__PURE__*/React$1.createElement(MediaQueryProvider$1, null, /*#__PURE__*/React$1.createElement(PortalsManager$1, null, /*#__PURE__*/React$1.createElement(FocusManager$1, null, children))))))))));
    }
  }]);
  return AppProvider;
}(Component);
export { AppProvider };